const CrudStore = require("stores/abstract/CrudStore");

class CrudStoreFabricator {
	constructor() {
		this.instances = {};
	}

	create(resource, constraints = {}, autofetch = true, key = null, context = null) {
		key = key ? resource+'_'+key : resource;

		if (typeof this.instances[key] === 'undefined') {
			this.instances[key] = new CrudStore(resource, constraints, autofetch, context);
		}

		return this.instances[key];
	}
}

module.exports = new CrudStoreFabricator;
